import type { FindFn } from "@shared/models/analytics/base"
import type { LessonAnalyticsCore } from "@shared/models/analytics/lesson"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import type { DefaultLessonModels } from "./default-lesson-models"

export function lessonAnalyticsCore(
  cardStackId: string,
  planbookId: string,
  models: DefaultLessonModels,
  findFn: FindFn,
  userId: string
): LessonAnalyticsCore {
  return {
    root_id: planbookId,
    root_type: "planbook",
    date_plan_scheduled_for: models.dateStringForCardStack,
    primary_object_id: cardStackId,
    primary_object_id_and_ancestor_ids: models.cardStackIdAndAncestorIds,
    primary_possessive: getPossessiveForPlanbook(findFn, userId, planbookId),
    primary_verb: "edit",
    primary_object_type: "lesson",
    adverbial_possessive: null,
  }
}
